import { Box, OutlinedInput } from "@mui/material";
import { BackgroundStyle, BigHeading, FlexContainer, LightBlueContainer, ListContainer, SearchingBoxContainer, LongBlueButton } from "../assets/style";
import RecordTable, { TableRow, TableHeader } from "../components/RecordTable";
import { useEffect, useState } from "react";
import SearchInput from "../components/SearchInput";
import SearchDatePicker from "../components/SearchDatePicker";
import dayjs from 'dayjs';
import SearchBox from "../components/SearchBox";
import { useNavigate } from "react-router-dom";
import MainContent from '../components/MainContent';
import { entryPageName } from "../components/PageName";
import { useLazyGetScheduleListingQuery } from "../features/schedule/scheduleSlice";
import RecordTableV2 from "../components/RecordTableV2";
import SearchDropDownList from "../components/SearchDropDownList";
import { useLazyGetContractDDLQuery } from "../features/contract/ContractSlice";
import { ContractItemModel } from "../models/ContractItemModel";
import { ProjectItemModel } from "../models/ProjectItemModel";
import { useLazyGetProjectByIdQuery, useLazyGetProjectDDLQuery } from "../features/project/projectSlice";
import { useTranslation } from "react-i18next";

const EntryListPage = () => {
    const { t, i18n } = useTranslation();
    const [getContractDDL] = useLazyGetContractDDLQuery();
    const [getProjectDDL] = useLazyGetProjectDDLQuery();
    const [projectNum, setProjectNum] = useState("");
    const [contract, setContract] = useState<ContractItemModel[]>([]);
    const [project, setProject] = useState<ProjectItemModel[]>([]);
    const [contractNum, setContractNum] = useState("");
    const [contractId, setContractId] = useState("");
    // const [date, setDate] = useState(dayjs());
    const [projectName, setProjectName] = useState("");
    const [projectId, setProjectId] = useState("");
    const [location, setLocation] = useState("");
    // const [locationOfConfinedSpace, setLocationOfConfinedSpace] = useState("");
    const navigate = useNavigate();
    const [getScheduleListQuery] = useLazyGetScheduleListingQuery();
    const [tableRows, setTableRows] = useState<any[]>([]);
    const [page, setPages] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [getProjectQuery] = useLazyGetProjectByIdQuery();
    // var length = 0;
    const columns: TableHeader[] = [
        { field: 'projectNumber', headerName: t('Project No.'), width: 200, isSortable: true },
        { field: 'projectName', headerName: t('Project Name'), width: 350, isSortable: true },
        { field: 'location', headerName: t('Location'), width: 250, isSortable: false },
        { field: 'locationOfConfinedSpace', headerName: t('Location of Confined Space'), width: 300, isSortable: false },
        { field: 'date', headerName: t('Date'), width: 100, isSortable: false },
        { field: 'scheduleStartTime', headerName: t('Start Time'), width: 100, isSortable: false },
        { field: 'scheduleEndTime', headerName: t('End Time'), width: 100, isSortable: false },
        { field: 'status', headerName: t('Status'), width: 250, isSortable: false },
    ];
    const fetchDataForPage = async (pageNumber: any) => {
        // Fetch data for the specified page from the backend
        const scheduleData = await getScheduleListQuery({ contractId: contractId?.toString(), projectId: projectId?.toString(), page: pageNumber });
        if (scheduleData.status === 'fulfilled') {
            return scheduleData.data.records.map((item: any) => ({
                id: item.ScheduleId,
                projectNumber: item.projectNumber,
                projectName: item.projectName,
                location: item.locationName,
                locationOfConfinedSpace: item.locationNameOfConfinedSpace,
                date: item.scheduleWorkDate,
                scheduleStartTime: item.scheduleStartTime,
                scheduleEndTime: item.scheduleEndTime,
                status: t(item.scheduleStatus),
                locationId: item.locationId,
                projectId: item.projectId,
            }))
        }
        // return [];
    };

    useEffect(() => {
        getContractDDL().then((res) => {
            if (res.status == 'fulfilled') {
                const contractItems: ContractItemModel[] = res.data.map((item: any) => ({
                    id: item.id,
                    name: item.name,
                    title: item.title,
                }));
                const newContractItems: ContractItemModel[] = [
                    {
                        id: "",
                        name: "ALL",
                        title: "",
                    },
                    ...contractItems,
                ];

                setContract(newContractItems);
            }
        })

        getProjectDDL().then((res) => {
            if (res.status == 'fulfilled') {
                const projectItems: ProjectItemModel[] = res.data.map((item: any) => ({
                    id: item.id,
                    name: item.name,

                }));
                const newProjectItems: ProjectItemModel[] = [
                    {
                        id: "",
                        name: "ALL",
                    },
                    ...projectItems,
                ];

                setProject(newProjectItems);
            }
        })
    }, []);

    const handleEntryDetail = () => {
        getScheduleListQuery({
            contractId: contractId?.toString(),
            projectId: projectId?.toString(),
        })
            .then((schedule: any) => {
                if (schedule.status == 'fulfilled') {
                    // console.log("getScheduleQuery", schedule?.data)
                    const tableRows = schedule?.data.records.map((item: any) => ({
                        id: item.ScheduleId,
                        projectNumber: item.projectNumber,
                        projectName: item.projectName,
                        location: item.locationName,
                        locationOfConfinedSpace: item.locationNameOfConfinedSpace,
                        date: item.scheduleWorkDate,
                        scheduleStartTime: item.scheduleStartTime,
                        scheduleEndTime: item.scheduleEndTime,
                        status: t(item.scheduleStatus),
                        locationId: item.locationId,
                        projectId: item.projectId,
                    }))
                    setPages(schedule?.data?.totalPages)
                    setTableRows(tableRows)
                    setTotalCount(schedule?.data.totalCount)
                    // setLength(schedule?.)
                }
            })
    }
    useEffect(() => {
        handleEntryDetail()
    }, [])

    useEffect(() => {
        handleContractDDLonChange(contractNum)
    }, [contractNum])

    useEffect(() => {
        handleProjectDDLonChange(projectName)
    }, [projectName])

    const handleContractDDLonChange = (contractNumber: string) => {
        const matchType = contract.find((item) => item.name === contractNumber)?.id;
        if (matchType && contractNumber != "ALL")
            setContractId(matchType);
        else setContractId("");
    }

    const handleProjectDDLonChange = (projectName: string) => {
        const matchType = project.find((item) => item.name === projectName)?.id;
        if (matchType && projectName != "ALL")
            setProjectId(matchType);
        else setProjectId("");
    }
    const handleRowClick = (entry: any) => {
        // Handle the row click event and pass the row value to another page or component
        console.log("entry?.projectId dvvdvdvdvdvd", entry?.projectId)
        console.log("entry dvvdvdvdvdvd", entry)
        if (entry?.projectId)
            getProjectQuery(entry?.projectId)
                .then((respone) => {
                    console.log("respone?.data dvdvdvdv", respone?.data)
                    navigate('/entry-detail', { state: { entry: entry, project: respone?.data } })
                })
        // navigate('/entry-detail', { state: { entry: entry } })
    };

    return (
        <MainContent type={entryPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <ListContainer className="data-table-overide-styles">
                    <BigHeading>{t("Work Schedule")}</BigHeading>
                    <SearchingBoxContainer>
                        <SearchBox>
                            <FlexContainer>
                                <SearchDropDownList
                                    title={t("Contract")}
                                    value={contractNum}
                                    handleValueChange={(event: any) => setContractNum(event?.target?.value)}
                                    items={contract.map(item => item.name)}
                                />
                                {/* TODO */}
                                <SearchDropDownList
                                    title={t("Project")}
                                    value={projectName}
                                    handleValueChange={(event: any) => setProjectName(event?.target?.value)}
                                    items={project.map(item => item.name)}
                                />
                                {/* <SearchDropDownList title={"Location"} value={contractNum} handleValueChange={(event: any) => setContractNum(event?.target?.value)} items={contract.map(item => item.name)} /> */}
                                {/* <SearchDropDownList title={"Company"} value={contractNum} handleValueChange={(event: any) => setContractNum(event?.target?.value)} items={contract.map(item => item.name)} /> */}

                                {/* <SearchInput title={"Project No."} value={projectNum} setMethod={setProjectNum} />
                                <SearchInput title={"Project Name"} value={projectName} setMethod={setProjectName} /> */}
                            </FlexContainer>
                            {/* <FlexContainer>
                                <SearchInput title={"Location"} value={location} setMethod={setLocation} />
                                <SearchInput title={"Location of Confined Space"} value={locationOfConfinedSpace} setMethod={setLocationOfConfinedSpace} />
                                <SearchDatePicker title={"Date"} value={date} setMethod={setDate} />
                            </FlexContainer> */}
                            <FlexContainer>
                                <LongBlueButton onClick={handleEntryDetail}>{t("Search")}</LongBlueButton>
                            </FlexContainer>
                        </SearchBox>
                    </SearchingBoxContainer>
                    {
                        tableRows && <RecordTableV2 columns={columns} rows={tableRows} checkbox={false} pages={page} totalCount={totalCount} onClick={handleRowClick} updateTableRows={setTableRows} fetchDataForPage={fetchDataForPage}></RecordTableV2>
                    }</ListContainer>
            </BackgroundStyle>
        </MainContent>
    );
};
export default EntryListPage;